import "./DashboardLayout.css"
import icon from '../icon.png'
import * as React from "react";
import {ReactElement} from "react";
import {useAuth} from "../../providers/AuthProvider";
import {capitalize} from "../../utils/utils";
import {SideMenuButtons} from "./SideMenuButtons";
import {faBell, faChartLine, faGear} from "@fortawesome/free-solid-svg-icons";

export type DashboardProps = {
    children: ReactElement,
    active?: string
}


export function DashboardLayout(props: DashboardProps) {

    let authContext = useAuth();

    const activeButton = props.active


    return (
        <div className="app-container">
            <div className="app-header">
                <div className="app-header-left">
                    <span className="app-icon"/>
                    <p className="app-name">SalesCode.ai</p>
                </div>
                <div className="app-header-right">
                    <button className="profile-btn">
                        <img src={icon} alt={"profile-pic"} />
                        <div className={"profile-section"} >
                            <span>{capitalize(authContext.user.name)}</span>
                            <span style={{ textTransform: 'uppercase' }}>{capitalize(authContext.user.lob)}</span>
                        </div>
                    </button>
                </div>

            </div>
            {/*End of Header*/}

            <div className="app-content">
                <div className="app-sidebar">

                    <SideMenuButtons
                        icon={faChartLine}
                        buttonName="KPI Registry"
                        href="/"
                        isActive={activeButton === 'kpi'}
                        hrefClassName="app-sidebar-link  zoom"
                        svgClassName="link-icon feather feather-pie-chart"/>
                    <SideMenuButtons
                        icon={faBell}
                        buttonName="Smart Triggers"
                        href="/smart/triggers"
                        isActive={activeButton === 'smartTriggers'}
                        hrefClassName="app-sidebar-link zoom"
                        svgClassName="link-icon feather feather-settings"/>
                    <SideMenuButtons
                        icon={faGear}
                        buttonName="Settings"
                        href="/settings"
                        isActive={activeButton === 'Settings'}
                        hrefClassName="app-sidebar-link zoom"
                        svgClassName="link-icon feather feather-settings"
                        otherSvg={<circle cx="12" cy="12" r="3"/>}/>


                </div>
                <div className="main-section">
                    {props.children}
                </div>
            </div>
        </div>
    );
}
